var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink as ReactLink } from 'react-router-dom';
import styled, { css, useTheme } from '@xstyled/styled-components';
import { th } from '@xstyled/styled-components';
import { createRgba } from '../../utils';
var StyledLink = styled(ReactLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n  :visited {\n    color: ", ";\n  }\n  :hover {\n    color: ", ";\n  }\n  :active {\n    color: ", ";\n  }\n  :focus {\n    outline: none;\n  }\n  font-family: ", ";\n  font-size: ", ";\n\n  ", "\n"], ["\n  color: ", ";\n  cursor: pointer;\n  :visited {\n    color: ", ";\n  }\n  :hover {\n    color: ", ";\n  }\n  :active {\n    color: ", ";\n  }\n  :focus {\n    outline: none;\n  }\n  font-family: ", ";\n  font-size: ", ";\n\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return createRgba(color, 0.7);
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var color = _a.color;
    return color;
}, th('fonts.primary'), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          pointer-events: none;\n          opacity: 0.5;\n        "], ["\n          pointer-events: none;\n          opacity: 0.5;\n        "]))) : null;
});
var Link = function (props) {
    var theme = useTheme();
    var themeColor = props.color ? th.color(props.color)({ theme: theme }) : undefined;
    var themeFontSize = th.fontSize(props.size)({ theme: theme });
    return (_jsx(StyledLink, __assign({}, props, { color: themeColor, size: themeFontSize, children: props.children })));
};
Link.defaultProps = {
    to: '',
    color: 'linkColor',
    disabled: false,
    size: 1,
    padding: '0',
    replace: false,
};
export default Link;
var templateObject_1, templateObject_2;
